import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-card-shimmer',
  templateUrl: './wallet-card-shimmer.component.html',
  styleUrls: ['./wallet-card-shimmer.component.scss']
})
export class WalletCardShimmerComponent {

}
